// Phase 6 — Sales Report list table.
//
// Replaces the MUI <Table> + antd <Pagination> in ReportListScreen.tsx with the
// shared DataTable. Presentation only: the INR bill-amount formatting is the same
// Intl.NumberFormat the legacy used; pagination reuses the screen's offset math.
import * as React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "../../shared/data-table";

const inr = (v: any) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(v);

export interface ReportsTableProps {
  data: any[];
  loading: boolean;
  toolbar?: React.ReactNode;
  pagination: { page: number; total: number; onChange: (page: number) => void };
}

export function ReportsTable({ data, loading, toolbar, pagination }: ReportsTableProps) {
  const columns = React.useMemo<ColumnDef<any, any>[]>(
    () => [
      { id: "category", header: "Category", cell: ({ row }) => row.original?.category },
      { id: "subCategory", header: "Sub-Category", cell: ({ row }) => row.original?.subCategory },
      { id: "invoiceNumber", header: "Invoice Number", cell: ({ row }) => row.original?.invoiceNumber },
      { id: "month", header: "Month/Year", cell: ({ row }) => row.original?.month },
      {
        id: "billAmount",
        header: "Bill Amount",
        cell: ({ row }) => <span className="tabular-nums">{inr(row.original?.billAmount)}</span>,
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={data || []}
      loading={loading}
      toolbar={toolbar}
      pagination={pagination}
    />
  );
}

export default ReportsTable;
